import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { commaFormatted } from '../../../utils/transformer.util';
import { Button } from '../../../components/base/index';
import PengisianNilaiKognitif from './components/PengisianNilaiKognitif.component';
import NilaiKognitifTable from './components/NilaiKognitifTable.component';

export default class PengisianNilai extends PureComponent {
  constructor(props) {
    super(props);
    this._onFormChange = this._onFormChange.bind(this);
    this._onClickNext = this._onClickNext.bind(this);
    this.state = {
      form: {
        value: {},
        error: {},
      },
    };
  }

  _onFormChange(event) {
    const {
      name,
      value,
      dataset,
      files,
    } = event.target;
    const { inputType = 'text' } = dataset;
    this.setState((prevState) => {
      let formattedValue = value;
      if (inputType === 'number') {
        formattedValue = commaFormatted(value);
      }
      if (inputType === 'file') {
        [formattedValue] = files;
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            [name]: formattedValue,
          },
          error: {
            ...prevState.form.error,
            [name]: '',
          },
        },
      };
    });
  }

  _onClickNext() {
    const { history } = this.props;
    history.push('/dashboard/kesiswaan/laporan/daftar-siswa-kelas-unit');
  }


  render() {
    const { form } = this.state;
    return (

      <div className="student-list">
        <div className="budget__title">
          <h1>Pengisian Nilai </h1>
          <hr />
        </div>
        <form onSubmit={this._onSubmit}>

          <div className="result__content">
            <PengisianNilaiKognitif
              form={form}
              onFormChange={this._onFormChange}
            />
          </div>


          <NilaiKognitifTable
            form={form}
            onFormChange={this._onFormChange}
          />

          <div className="manage-registration__footer">
            <Button
              onClick={this._onClickSubmit}
              title="Submit"
            />
          </div>
        </form>
      </div>

    );
  }
}
PengisianNilai.propTypes = {
  handleGetKlapper: PropTypes.func,
  handleDeleteKlapper: PropTypes.func,
};
PengisianNilai.defaultProps = {
  handleGetKlapper: noop,
  handleDeleteKlapper: noop,
};
